import React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { useTheme, useMediaQuery } from '@mui/material';

export default function ResponsiveTabs({ value, onChange, tabs = [] }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Vista</InputLabel>
        <Select
          value={value}
          label="Vista"
          onChange={(e) => onChange(e, e.target.value)}
          sx={{ borderRadius: 2 }}
        >
          {tabs.map((tab, index) => (
            <MenuItem key={index} value={index}>
              {tab.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Tabs
      value={value}
      onChange={onChange}
      sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}
    >
      {tabs.map((tab, index) => (
        <Tab key={index} label={tab.label} value={index} />
      ))}
    </Tabs>
  );
}
